import { authFetch } from './auth';

const handle = async r => {
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.error || `Error ${r.status}`);
  return data;
};

// Folders
export const getFolders    = ()        => authFetch('/api/folders').then(handle);
export const createFolder  = data      => authFetch('/api/folders', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) }).then(handle);
export const updateFolder  = (id, d)   => authFetch(`/api/folders/${id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(d) }).then(handle);
export const deleteFolder  = id        => authFetch(`/api/folders/${id}`, { method: 'DELETE' }).then(handle);

// Priorities
export const getPriorities   = ()       => authFetch('/api/priorities').then(handle);
export const createPriority  = data     => authFetch('/api/priorities', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) }).then(handle);
export const updatePriority  = (id, d)  => authFetch(`/api/priorities/${id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(d) }).then(handle);
export const deletePriority  = id       => authFetch(`/api/priorities/${id}`, { method: 'DELETE' }).then(handle);

// Tasks
export const getTasks = (filters = {}) => {
  const p = new URLSearchParams();
  if (filters.statuses?.length)     p.set('statuses',      filters.statuses.join(','));
  if (filters.before_date)          p.set('before_date',   filters.before_date);
  if (filters.folder_ids?.length)   p.set('folder_ids',    filters.folder_ids.join(','));
  if (filters.priority_ids?.length) p.set('priority_ids',  filters.priority_ids.join(','));
  if (filters.search?.trim())       p.set('search',        filters.search.trim());
  const qs = p.toString();
  return authFetch(`/api/tasks${qs ? '?' + qs : ''}`).then(handle);
};

export const createTask = data      => authFetch('/api/tasks', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) }).then(handle);
export const updateTask = (id, d)   => authFetch(`/api/tasks/${id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(d) }).then(handle);
export const deleteTask = id        => authFetch(`/api/tasks/${id}`, { method: 'DELETE' }).then(handle);
